import { Helmet } from "react-helmet-async";

import { Navbar } from "@/components/landing/Navbar";
import { HeroSection } from "@/components/landing/HeroSection";
import { CreatorsNeedYouSection } from "@/components/landing/CreatorsNeedYouSection";
import { FourStepsSection } from "@/components/landing/FourStepsSection";
import { FeaturesSection } from "@/components/landing/FeaturesSection";

import { CreatorCalculatorSection } from "@/components/landing/CreatorCalculatorSection";
import { TestimonialsSection } from "@/components/landing/TestimonialsSection";
import { PricingSection } from "@/components/landing/PricingSection";
import { GuaranteeSection } from "@/components/landing/GuaranteeSection";
import { FounderSection } from "@/components/landing/FounderSection";
import { BonusCourseSection } from "@/components/landing/BonusCourseSection";
import { FAQSection } from "@/components/landing/FAQSection";
import { FinalCTASection } from "@/components/landing/FinalCTASection";
import { FreeTrialTimeline } from "@/components/landing/FreeTrialTimeline";
import { FooterSection } from "@/components/landing/FooterSection";
import { MobileStickyBar } from "@/components/landing/MobileStickyBar";
import { ExitIntentPopup } from "@/components/landing/ExitIntentPopup";
import { HomepageMarquee } from "@/components/landing/HomepageMarquee";
import { SectionDivider } from "@/components/landing/SectionDivider";

const faqStructuredData = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    { "@type": "Question", "name": "How is this different from just using ChatGPT?", "acceptedAnswer": { "@type": "Answer", "text": "ChatGPT is a general-purpose AI. AI StoryCraft Studio is purpose-built for creator monetisation — it uses real keyword data to find what your audience is searching for, then builds products specifically designed to sell to that audience." }},
    { "@type": "Question", "name": "What if my niche is too small or obscure?", "acceptedAnswer": { "@type": "Answer", "text": "The smaller and more specific your niche, the better this works. A fitness creator with 500 followers in 'postpartum core recovery' will outsell a generic fitness page with 50,000 followers." }},
    { "@type": "Question", "name": "I only have 500 followers. Is this really worth it for me?", "acceptedAnswer": { "@type": "Answer", "text": "Yes — 500 followers at a 1% conversion rate buying a $47 product is $235/month. That is more than TikTok pays for 10 million views." }},
    { "@type": "Question", "name": "Can I cancel anytime?", "acceptedAnswer": { "@type": "Answer", "text": "Yes. Cancel anytime from your account settings. No cancellation fees. No questions asked." }},
    { "@type": "Question", "name": "What happens after my 7-day free trial?", "acceptedAnswer": { "@type": "Answer", "text": "After your trial ends, you'll be charged your chosen plan rate. You'll receive an email reminder 24 hours before your trial ends. You can cancel at any time before then with no charge." }},
  ]
};

const Index = () => {
  return (
    <div className="min-h-screen relative overflow-hidden" style={{ background: "#FAFAFA" }}>
      <Helmet>
        <title>AI StoryCraft Studio — Turn Any Audience Into Income With AI</title>
        <meta name="description" content="AI Storycraft Studio helps creators with 500+ followers build digital products, sales pages, and launch plans in one click. Start your free trial today." />
        <meta property="og:title" content="AI StoryCraft Studio — Turn Any Audience Into Income With AI" />
        <meta property="og:description" content="AI Storycraft Studio helps creators with 500+ followers build digital products, sales pages, and launch plans in one click. Start your free trial today." />
        <meta property="og:image" content="https://ai-storycraft-studio.com/mockups/mockup-nexis-ai.png" />
        <link rel="canonical" href="https://ai-storycraft-studio.com/" />
        <script type="application/ld+json">{JSON.stringify(faqStructuredData)}</script>
      </Helmet>
      
      <Navbar />
      <main className="relative z-10">
        <HeroSection />
        <HomepageMarquee />
        <CreatorsNeedYouSection />
        <SectionDivider from="#FAFAFA" to="#FFFFFF" />
        <FourStepsSection />
        <SectionDivider from="#FAFAFA" to="#FFFFFF" />
        <TestimonialsSection />
        <SectionDivider from="#FFFFFF" to="#FAFAFA" />
        <PricingSection />
        <BonusCourseSection />
        <GuaranteeSection />
        <SectionDivider from="#FAFAFA" to="#FFFFFF" />
        <FreeTrialTimeline />
        <FounderSection />
        <FAQSection />
        <SectionDivider from="#FAFAFA" to="#faf5ff" />
        <FinalCTASection />
      </main>
      <FooterSection />
      <MobileStickyBar />
      <ExitIntentPopup />
    </div>
  );
};

export default Index;
